import { RadioGroup as ChakraRadioGroup } from '@chakra-ui/react';
import * as React from 'react';

interface RadioItemProps extends ChakraRadioGroup.ItemProps {
  rootRef?: React.Ref<HTMLDivElement>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const RadioItem = React.forwardRef<HTMLInputElement, RadioItemProps>(
  function Radio(props, ref) {
    const { children, inputProps, rootRef, ...rest } = props;
    return (
      <ChakraRadioGroup.Item ref={rootRef} cursor="pointer" {...rest}>
        <ChakraRadioGroup.ItemHiddenInput ref={ref} {...inputProps} />
        <ChakraRadioGroup.ItemIndicator
          borderColor="gray.500"
          _checked={{ background: 'green.700', borderColor: 'green.700' }}
        />
        {children && (
          <ChakraRadioGroup.ItemText>{children}</ChakraRadioGroup.ItemText>
        )}
      </ChakraRadioGroup.Item>
    );
  }
);

const Radio = {
  Group: ChakraRadioGroup.Root,
  Item: RadioItem,
};

export default Radio;
